import {handleListReorder} from 'common/components/draggable-list/utils';

import {BookmarkDragOperationProps} from './types';
import {generateFilter} from './utils';

/**
 * Handles rearranging the global filters section when dragging and dropping filters.
 */
export function handleGlobalFiltersRearrange(props: BookmarkDragOperationProps) {
  handleListReorder({
    event: props.event,
    entries: props.params.sections.filter!,
    entryGenerator: (filter, opts) => generateFilter(filter, opts)?.result,
    setEntries: (updatedEntries) => {
      props.updateParams((draft) => {
        draft.sections.filter = updatedEntries;
      });
    },
  });
}
